// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"592e6685","897":"da4ff823"}[chunkId] + ".chunk.css";
};